if (!customElements.get('ct-product')) {
  customElements.define(
    'ct-product',
    class CTProduct extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          mainSwiperDiv: null,
          mainSwiper: null,
          thumbsSwiperDiv: null,
          thumbsSwiper: null,
          productOverlay: null
        }
        this._initialized = false;
      }

      connectedCallback() {
        if (this._initialized) return;

        this.elements.mainSwiperDiv = this.querySelector('.swiper');
        this.elements.thumbsSwiperDiv = this.querySelector('.swiper--thumbs');

        if (!this.elements.mainSwiperDiv || !this.elements.thumbsSwiperDiv) return;

        if (typeof Swiper === 'undefined') {
          window.addEventListener('load', () => this.init(), { once: true });
          return;
        }

        this.init();
      }

      disconnectedCallback() {
        this._destroySwipers();
        this._initialized = false;
      }

      _destroySwipers() {
        const main = this.elements.mainSwiper || (this.elements.mainSwiperDiv && this.elements.mainSwiperDiv.swiper);
        const thumbs = this.elements.thumbsSwiper || (this.elements.thumbsSwiperDiv && this.elements.thumbsSwiperDiv.swiper);
        if (main && typeof main.destroy === 'function') {
          try { main.destroy(true, true); } catch (e) {}
        }
        if (thumbs && typeof thumbs.destroy === 'function') {
          try { thumbs.destroy(true, true); } catch (e) {}
        }
        this.elements.mainSwiper = null;
        this.elements.thumbsSwiper = null;
      }

      init() {
        if (this._initialized) return;

        this._destroySwipers();

        this.elements.thumbsSwiper = new Swiper(this.elements.thumbsSwiperDiv, {
          spaceBetween: 5,
          slidesPerView: 3.5,
          watchSlidesProgress: true,
          freeMode: true,
          loop: true,
        });

        this.elements.mainSwiper = new Swiper(this.elements.mainSwiperDiv, {
          spaceBetween: 5,
          slidesPerView: 1,
          loop: true,
          thumbs: {
            swiper: this.elements.thumbsSwiper
          }
        });

        this.elements.productOverlay = this.querySelector('.ct-product__overlay');

        if (this.elements.productOverlay) {
          this.elements.productOverlay.addEventListener('click', () => {
            document.body.classList.remove('size-chart-is-open');
          });
        }

        this._initialized = true;
      }
    }
  );
}
